<template>
  <Drawer v-model:visible="isVisible" v-bind="$attrs" :position="position" :modal="modal"
      :closeOnEscape="closeOnEscape" :dismissable="dismissable" :showCloseIcon="showCloseIcon"
      :baseZIndex="baseZIndex" :autoZIndex="autoZIndex" :style="style" :class="className" @show="$emit('show')"
      @hide="$emit('hide')" @after-hide="$emit('after-hide')">
      <template v-if="$slots.header" #header>
          <slot name="header"></slot>
      </template>
      <slot></slot>
      <template v-if="$slots.footer" #footer>
          <slot name="footer"></slot>
      </template>
  </Drawer>
</template>

<script setup lang="ts">
// @ts-ignore
import Drawer from 'primevue/drawer';
import { computed } from 'vue';

defineOptions({
  name: 'ONEDrawer'
});

interface Props {
  modelValue?: boolean;
  position?: 'left' | 'right' | 'top' | 'bottom' | 'full';
  style?: string;
  className?: string;
  showCloseIcon?: boolean;
  modal?: boolean;
  dismissable?: boolean;
  closeOnEscape?: boolean;
  baseZIndex?: number;
  autoZIndex?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modal: true,
  dismissable: true,
  closeOnEscape: true,
  showCloseIcon: true,
  baseZIndex: 0,
  autoZIndex: true
});

const emit = defineEmits(['update:modelValue', 'show', 'hide', 'after-hide']);

const isVisible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value)
});
</script>
